
import { EventEmitter } from "events";
import { AxiosRestApplicationClient } from "../model/model.ts";
import { LoginPostDTO } from "../model/model";
import type { UserData } from "../model/model";
import * as Axios from "axios";
import axios from "axios";
import { w3cwebsocket as W3CWebSocket } from "websocket";

class SessionStore extends EventEmitter {
  client: AxiosRestApplicationClient;
  userData?: UserData;
 
  constructor() {
    super();

    const axiosInstance = axios.create();
    axiosInstance.interceptors.response.use(
      response => response,
      error => {
        if (error.response?.status === 401) {
          this.logout(true, () => {
            window.location.href = '/login';
          });
        }
        return Promise.reject(error);
      }
    );
    this.client = new AxiosRestApplicationClient("/api/v1/", axiosInstance);
      this.fetchProfile(() => {});
  }

  login = (username: string, password: string, callbackFunc: () => void) => {
    var req: LoginPostDTO = {username, password};
    this.client.loginPost(req).then((resp) => {
      this.userData = resp.data.userData;
      console.log('user',this.userData);
      if(!!this.userData){
        this.setToken(resp.data.token);
        this.setSubId(this.userData.subId);
        this.setOrgId(this.userData.orgId);
        this.setSiteId(this.userData.siteId);
      }
      this.emit("change");
    callbackFunc();
    });
  };

  logout = (emit: boolean, callbackFunc: () => void) => {
    localStorage.clear();
    this.userData = undefined;

    if (emit === true) {
      this.emit("change");
    }

    callbackFunc();
  };


  fetchProfile = (callbackFunc: () => void) => {
    if (this.getToken() === "") {
      return;
    }

    this.client.getusersess(this.getBearer()).then((resp) => {
      this.userData = resp.data.userData;
      this.emit("change");
      callbackFunc();
    });
  };


  setToken = (s: string) => {
    console.log("token set to", s);
    localStorage.setItem("token", s);
  };
  
  getBearer = (): Axios.AxiosRequestConfig => {
    const token = localStorage.getItem("token");
    if (token == null) {
      return {};
    }
    return { headers: {"Authorization" : `Bearer ${token}`} };
  };

  getToken = (): string => {
    const token = localStorage.getItem("token");
    if (token == null) {
      return "";
    }
    return token;
  };

  getOrgId = (): string => {
    return localStorage.getItem("orgId") || "";
  };

  setOrgId = (id: string) => {
    console.log("orgId set to", id);
    localStorage.setItem("orgId", id);
    this.emit("org.change");
  };

  setSubId = (id: string) => {
    console.log("subId set to", id);
    localStorage.setItem("subId", id);
    this.emit("sub.change");
  };

  getSubId = (): string => {
    return localStorage.getItem("subId") || "";
  };

  getSiteId = (): string => {
    return localStorage.getItem("siteId") || "";
  };

  setSiteId = (id: string) => {
    console.log("siteId set to", id);
    localStorage.setItem("siteId", id);
    this.emit("site.change");
  };


  getRowsPerPage = (): number => {
    return parseInt(localStorage.getItem("rowsPerPage") || "10", 10);
  };

  setRowsPerPage = (count: number) => {
    localStorage.setItem("rowsPerPage", count.toString());
  };

  getUser = (): UserData | undefined => {
    return this.userData;
  };

  getClient = (): AxiosRestApplicationClient => {
    return this.client;
  };
  
  socket: any = undefined;
  connectSocket = (onSocketMsg?: Function, onSocketOpen?: Function, onSocketClose?: Function) => {

    if (!this.socket) {
      const accessToken = this.getToken();
      if (accessToken) {
        let websockServer = "ws://" + window.location.host + "/wsj";
        if (window.location.protocol === "https:") {
          websockServer = "wss://" + window.location.host + "/wsj";
        }
        websockServer = "ws://localhost:8800/wsj"; //todo remove
        console.log("Connecting to websockServer:", websockServer);
        this.socket = new W3CWebSocket(websockServer+ "?Authorization=Bearer " + accessToken);
        console.log("socket:", this.socket);
      }
    }
    if (onSocketOpen) {
      this.socket.onopen = () => {
        console.log("onSocketOpen:");
        onSocketOpen();
      }
    }
    if (onSocketMsg) {
      this.socket.onmessage = (message: any) => {
        //console.log("onSocketMsg", message);
        onSocketMsg(message);
      }
    }
    if (onSocketClose) {
      this.socket.onclose = (err: any) => {
        console.log("onSocketClose",err);
        this.socket = undefined;
        onSocketClose(err);
      }
    }
  }
  socketMessage = (msg:any) =>{
    console.log("socketMessage:"+msg +" sock:"+this.socket);
    if (this.socket) {
      if(this.socket.readyState === 1){
        console.log("socket.send");
        this.socket.send(msg);
      }
    }
  }
}

const sessionStore = new SessionStore();
export default sessionStore;
